import React from "react";
import { LI } from "../../../AbstractElements";
import { CreditCard } from "react-feather";
import { Link } from "react-router-dom";
import { UncontrolledTooltip } from "reactstrap";

const WALLET_SHORTCUT_TARGET_ID = "wallet-shortcut";

/**
 * Кошелёк в шапке — рядом с профилем, как просил Максим 22.08.2026.
 *
 * Баланс числом здесь не показываем: сумма рядом с иконкой на каждой
 * странице превращает кабинет в биржевое табло, а точность требует запроса
 * при каждой отрисовке. Цифры — внутри раздела.
 */
const WalletShortcut = () => (
  <>
    <LI attrLI={{ id: WALLET_SHORTCUT_TARGET_ID, className: "fw-wallet-shortcut" }}>
      <div className="notification-box">
        <Link to={`${process.env.PUBLIC_URL}/wallet`}>
          <CreditCard />
        </Link>
      </div>
    </LI>
    <UncontrolledTooltip placement="bottom" target={WALLET_SHORTCUT_TARGET_ID}>
      Кошелёк
    </UncontrolledTooltip>
  </>
);

export default WalletShortcut;
